export default  {
    bindings: {
        property: '<',
        formTab: '=',
        categories: '<',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: require('../views/property.settings.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.settings.component.js